import _ from 'lodash'
import config from 'scoreboard/components/config'
import constants from 'scoreboard/components/constants'
import i18n from 'scoreboard/components/i18n'

/**
 * Tests whether the given scorecard item is valid to use as a chart data serie
 * source. Note that the item must have scoringTypeId populated (usually by
 * passing scoringType=true in the API call to the server)
 *
 * @param {TreeScorecardNode} item
 *
 * @returns {String} an error message if the scorecard item is invalid; null if
 * the item is valid
 */
function testScorecardItemSerie (item) {
	if (!item) {
		// "isRequired" will be enforced elsewhere; nothing to do here if they
		// haven't selected an item to validate
		return
	}

	let scoringType = _.find(config.scoringTypes, type => type.id == item.scoringTypeId)
	if (!scoringType) {
		return
	}

	if (scoringType.kpiValueType === constants.UNSCORED_TEXT) {
		// #47453
		return i18n.get('charts.error.cannotUseUnscoredText')
	}
}

export default testScorecardItemSerie

testScorecardItemSerie.__filename__ = 'charts/edit/serie/test-scorecard-item-serie.js'
